export default __webpack_public_path__ + "static/media/zappayEmptyState.96aaebb7.png";